import { Typography, Box } from '@mui/material';
import { ToggleColorMode, OutlinedButton } from '../components/index';
import ForbiddenImage from '../assets/images/403.png';
import { useNavigate } from 'react-router-dom';

const style = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  margin: 'auto',
  height: '100vh',
};

export const Forbidden = () => {
  let navigate = useNavigate();

  const routeChange = () => {
    let path = '/';
    navigate(path);
  };

  return (
    <ToggleColorMode mode={'dark'}>
      <Box sx={style}>
        <img
          src={ForbiddenImage}
          style={{ display: 'flex', marginBottom: '2rem' }}
          alt="forbidden"
          width="30%"
        />
        <Typography variant="h3" sx={{ fontWeight: '800' }}>
          Access Denied
        </Typography>
        <Typography>The page you're trying to access is restricted.</Typography>
        <Typography>Please refer to your administrator.</Typography>
        <OutlinedButton
          onClick={routeChange}
          style={{ mt: 5 }}
          btnTitle="Go Back"
        />
      </Box>
    </ToggleColorMode>
  );
};
